var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.checkWidth() + ' ' + 'container'},[(_vm.loading)?[_c('div',{staticClass:"container vertical-center"},[_c('LoadingMDL')],1)]:_vm._e(),[_c('PopupConver',{attrs:{"cardContent":_vm.content,"isAddQueueShow":_vm.openModalConver,"nextTo":_vm.funcRoute,"checkWidth":_vm.CheckWidth}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }